import { OddsFormat } from '@ps/web-core-enums';
import React, { useContext } from 'react';
import { FormattedNumber } from 'react-intl';

import { OddsFormatContext } from '@swf/sports/providers/OddsFormatProvider';
import type { BetPriceOdds as BetPriceOddsType } from '@swf/sports/types/odds';

export type Props = BetPriceOddsType;

const BetPriceOdds: React.FC<Props> = (props) => {
  const { decimalDisplayOdds, trueOdds, americanDisplayOdds } = props;

  const { oddsFormat } = useContext(OddsFormatContext);
  const decimal = decimalDisplayOdds?.decimalOdds ?? trueOdds.decimalOdds?.decimalOdds;
  const americanOddsInt = americanDisplayOdds?.americanOddsInt || americanDisplayOdds?.americanOdds;

  if (oddsFormat === OddsFormat.American && americanOddsInt) {
    return <span>{americanOddsInt > 0 ? `+${americanOddsInt}` : `${americanOddsInt}`}</span>;
  }

  if (oddsFormat === OddsFormat.Decimal) {
    return (
      <FormattedNumber
        style="decimal"
        minimumFractionDigits={2}
        maximumFractionDigits={2}
        value={decimal || 0}
      />
    );
  }

  return (
    <>
      <FormattedNumber style="decimal" value={(decimal || 0) - 1} />
      {'/1'}
    </>
  );
};

export { BetPriceOdds };
